


































































import { Component, PropSync, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import moment from 'moment';
import { ExportData } from '@/interface/components';

@Component
export default class ModalExport extends Vue {
  @PropSync('dialogVisibleExport', { type: Boolean }) syncedDialogVisibleExport!: boolean;

  @Action('getExportRequest', { namespace: 'request' }) c_getExportRequest!: any;
  @Action('getExportInventory', { namespace: 'inventory' }) c_getExportInventory!: any;
  @Action('getExport') c_getExport!: any;

  public dateRange = [];
  public selected = 'second';
  public timeCtrl: any = null;
  public currentDownloading = 0;
  public isLoading: boolean = false;

  async fileDownload() {
    this.isLoading = true;
    const groupId: string = this.$route.params.groupId;
    let result: ExportData;
    let linkEl: any = document.createElement('a');
    let startAt = '';
    let endAt = '';
    if (this.selected === 'first') {
      startAt = moment(this.dateRange[0]).format('YYYY-MM-DD');
      endAt = moment(this.dateRange[1]).format('YYYY-MM-DD');
    }
    try {
      this.$route.name === 'StatusView'
        ? (result = await this.c_getExportRequest({ groupId, startAt, endAt }))
        : (result = await this.c_getExportInventory({ groupId, startAt, endAt }));
      this.timeCtrl = setInterval(async () => {
        const iter = await this.c_getExport({ exportId: result.id });
        this.currentDownloading = iter.progress;
        if (iter.status === 'DONE') {
          await clearInterval(this.timeCtrl);
          await (() => {
            linkEl.setAttribute('href', iter.url);
            (this.$refs.dataList as any).appendChild(linkEl);
            linkEl.click();
            (this.$refs.dataList as any).removeChild(linkEl);
            linkEl = null;
          })();
          setTimeout(this.handleClose, 1000);
        }
      }, 500);
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.message);
      this.isLoading = false;
    }
  }

  handleClose() {
    this.syncedDialogVisibleExport = false;
    this.isLoading = false;
  }
}
